import React from 'react';
import { Accordion } from '@chargify/custom-ui-components';
import { FilterBoxList } from './FilterBox.styles';

export interface FilterBoxProps {
  children: React.ReactNode;
  isExpanded: boolean;
  onClick: () => void;
  header: string;
}

export const FilterBox = ({
  children,
  isExpanded,
  onClick,
  header,
}: FilterBoxProps) => {
  return (
    <Accordion
      header={header}
      onClick={onClick}
      isExpanded={isExpanded}
      variant={'small'}
    >
      <FilterBoxList>{children}</FilterBoxList>
    </Accordion>
  );
};
